export const gptFeatureKey = 'gpt';
export const coreFeatureKey = 'core';
export const userFeatureKey = 'user';
export const moneyFeatureKey = 'money';
export const uploadFeatureKey = 'upload';
export const lookupsFeatureKey = 'lookups';
export const generalFeatureKey = 'general';
export const chatbotFeatureKey = 'chatbot';
export const feedbackFeatureKey = 'feedback';
